module.exports = __webpack_public_path__ + "static/media/icon-volume-high.e7c4c2ca.svg";